module.exports = __webpack_public_path__ + "img/character-11.5260ead9.png";